import { CoreMsgTypes, StatisticsReport } from '@tassat/fred-definitions';

export interface DailyStatisticsState {
    [key: string]: StatisticsReport;
}

const initialState: DailyStatisticsState = {} as DailyStatisticsState;

export default function dailyStatisticsReducer(state = initialState, action) {
    switch (action.type) {
        case 'InitialLoad':
            return {
                ...state,
                ...action.payload.statistic
            };
        case CoreMsgTypes.StatisticsReport:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
}